/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import { unselectable } from 'stylesheets/base.scss';
import PropTypes        from 'prop-types';
import Icon             from 'components/Icon/Icon.react';
import React            from 'react';
import styles           from 'components/Button/Button.scss';

const noop = () => {};

let Button = (props) => {
  const hasOnClick = props.onClick && !props.disabled;
  let classes = [styles.button, unselectable];
  let icon = null;
  // if a button is disabled, that overrides any color selection
  if (props.disabled) {
    classes.push(styles.disabled);
    if (props.color === 'white') {
      // This has a special disabled case
      classes.push(styles.white);
    }
  } else {
    if (props.primary) {
      classes.push(styles.primary);
    }
    if (props.color) {
      classes.push(styles[props.color]);
    }

    if (props.icon) {
      icon = <Icon width={props.iconSize ? props.iconSize : 14} height={props.iconSize ? props.iconSize : 14} colored={props.colored ? true : false} name={props.icon} />;
    }
    if (props.progress) {
      classes.push(styles.progress);
    }
  }
  let clickHandler = hasOnClick ? props.onClick : noop;
  let styleOverride = null;
  if (props.width) {
    styleOverride = { width: props.width, minWidth: props.width, ...props.additionalStyles };
  }

  if (props.theme == 'dark') {
    classes.push(styles.dark);
  }

  if (props.size == 'big') {
    classes.push(styles.big);
  }

  if (props.size == 'small') {
    classes.push(styles.small);
  }

  if (props.block) {
    classes.push(styles.block);
  }

  const targetProp = {};

  if (props.target) {
    targetProp.target = props.target;
  }

  return (
    <a
      href={props.href && !props.disabled? props.href : 'javascript:;'}
      role='button'
      {...targetProp}
      style={styleOverride}
      className={classes.join(' ')}
      onClick={clickHandler}
      onFocus={(e) => { if (props.disabled) e.target.blur(); }} >
      {icon}
      {
        props.value
          ?
            <span>{props.value}</span>
          :
            null
      }

    </a>
  );
}

export default Button;

Button.propTypes = {
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf(['blue', 'green', 'red', 'white']),
  onClick: PropTypes.func,
  value: PropTypes.string.isRequired,
  href: PropTypes.string,
  width: PropTypes.string,
  progress: PropTypes.bool,
  colored: PropTypes.bool,
  additionalStyles: PropTypes.object,
};
